export const hero = {
	image: require("../../assets/imgs/home/hero-main.webp"),
	imageMobile: require("../../assets/imgs/home/mobile/hero-main.png"),
	imageAlt: "Land Rover Defender driving through water",
};

export const channelSections = [
	{
		eyebrow: "Open AI Ads",
		title: "Exclusive access to run ads in OpenAI's ChatGPT platform",
		paragraph:
			"Opportunity to be a first-mover in the OpenAI space with early beta access to ChatGPT's ad platform. This allows your dealership to show up in the most highly relevant AI conversations.",
		image: require("../../assets/imgs/home/service-openai-ads.webp"),
		imageMobile: require("../../assets/imgs/home/mobile/service-openai-ads.png"),
		imageAlt:
			"ChatGPT conversation surfacing a Range Rover Sport recommendation.",
		variant: "imageLeft",
	},
	{
		eyebrow: "SEO + AEO",
		title: "Rank in search. And now in AI answer engines.",
		paragraph:
			"Over 60% of Google searches now end without a click — the answer appears directly in ChatGPT, Gemini, or Perplexity. Our SEO+AEO program ensures your dealership surfaces in both.",
		image: require("../../assets/imgs/home/service-seo-aeo.webp"),
		imageMobile: require("../../assets/imgs/home/mobile/service-seo-aeo.png"),
		imageAlt:
			"AI answer engine results page featuring Land Rover vehicles.",
		variant: "imageRight",
	},
	{
		eyebrow: "NBC Spot On",
		title: "Deliver customized ads in NBCUniversal's premier programming — from NBC Sunday Night Football to the World Cup",
		paragraph:
			"With turnkey, zip code-level targeting, you'll stream alongside the world's most iconic advertisers across Peacock, NBCUniversal, Telemundo, and 85+ top media brands.",
		image: require("../../assets/imgs/home/service-nbc-spot-on.webp"),
		imageMobile: require("../../assets/imgs/home/mobile/service-nbc-spot-on.png"),
		imageAlt:
			"NBC streaming UI placing a Range Rover Sport ad alongside premium content tiles.",
		variant: "imageLeft",
	},
	{
		eyebrow: "Meta Ads",
		title: "Turn motion into thumb stopping moments",
		paragraph:
			"Meta combines advanced creative and targeted audiences with VIN-level automation to show shoppers the specific vehicles they are most likely to buy.",
		image: require("../../assets/imgs/home/service-meta-ads.webp"),
		imageMobile: require("../../assets/imgs/home/mobile/service-meta-ads.png"),
		imageAlt:
			"Facebook and Instagram feed mockup with Land Rover vehicle creative.",
		variant: "imageRight",
	},
	{
		eyebrow: "Google Ads",
		title: "Smarter search. Stronger results.",
		paragraph:
			"Leverage Google's most advanced ad formats — Search, AI Max, and Vehicle Listing Ads — powered by Constellation's proprietary VIN Prioritization to maximize visibility where buyers are searching.",
		image: require("../../assets/imgs/home/service-google-ads.webp"),
		imageMobile: require("../../assets/imgs/home/mobile/service-google-ads.png"),
		imageAlt:
			"Google search results page showing multiple Land Rover Defender listings with VIN-level detail.",
		variant: "imageLeft",
		badges: ["Search / AI Max", "Video (YouTube)", "Vehicle Listing Ads"],
	},
	{
		layout: "columnTile",
		eyebrow: "Content Automation",
		title: "Brand-compliant creative at scale. Without the production timeline.",
		paragraph:
			"Content Automation replaces weeks of production with minutes, instantly generating brand-compliant, inventory-aware copy and creative across all digital touchpoints.",
		image: require("../../assets/imgs/home/service-content-automation.webp"),
		imageMobile: require("../../assets/imgs/home/mobile/service-content-automation.png"),
		imageAlt:
			"Grid of brand-compliant Land Rover and Range Rover creative variants generated from a single template.",
	},
	// {
	// 	layout: "columnTile",
	// 	eyebrow: "Gen-AI Imaging",
	// 	title: "Photorealistic vehicle imagery. Without a photo shoot.",
	// 	paragraph:
	// 		"GenAI Imaging replaces costly, static photography by instantly transforming vehicle photos into JLR-compliant lifestyle imagery set in any environment or season.",
	// 	image: require("../../assets/imgs/home/service-genai-imaging.webp"),
	// 	imageMobile: require("../../assets/imgs/home/mobile/service-genai-imaging.png"),
	// 	imageAlt:
	// 		"A single Land Rover photo recomposed into five lifestyle environments — rain, snow, neutral studio, sunset, and night.",
	// },
];

export const enrollmentSteps = [
	{
		step: "01",
		title: "Select your product",
		body: "Select the channels and services that fit your retail goals. Set your monthly budget for each.",
	},
	{
		step: "02",
		title: "Enter retailer information",
		body: "Provide your retailer details and review your full program enrollment. Takes under 5 minutes.",
	},
	{
		step: "03",
		title: "Constellation activates",
		body: "Our team sets up your campaigns, and verifies when you launch.",
	},
	{
		step: "04",
		title: "Campaigns go live",
		body: "You receive performance reports and dashboards with hands-on management the whole way through.",
	},
];
